export const normalizeCamelCaseToUI = (text: string, capitalize?: boolean): string => {
	const normalized = text.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();

	return capitalize
		? normalized.replace(/\b\w/g, function (char) {
				return char.toUpperCase();
			})
		: normalized;
};
